import { render, staticRenderFns } from "./InfluencerSubCategoryCreate.vue?vue&type=template&id=1f4981bc"
import script from "./InfluencerSubCategoryCreate.vue?vue&type=script&lang=js"
export * from "./InfluencerSubCategoryCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports